import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ErrorBoundary from './components/UI/ErrorBoundary';
import Timeline from './components/Timeline/Timeline';
import ContentPage from './pages/ContentPage';
import ContentCreatePage from './pages/ContentCreatePage';
import ContentEditPage from './pages/ContentEditPage';
import BoardPage from './pages/BoardPage';
import BoardCreatePage from './pages/BoardCreatePage';
import BoardEditPage from './pages/BoardEditPage';
import BoardDetailPage from './pages/BoardDetailPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import MyPage from './pages/MyPage';
import Header from './components/UI/Header';
import ResponsiveLayout from './components/UI/ResponsiveLayout';
import NotificationSocket from './components/Notification/NotificationSocket';
import AdminPage from './pages/AdminPage';
import DashboardPage from './pages/DashboardPage';
import ApiDocsPage from './pages/ApiDocsPage';
import CategoryManagePage from './pages/CategoryManagePage';
import TopicAreaListPage from './pages/TopicAreaListPage';
import TopicAreaDetailPage from './pages/TopicAreaDetailPage';
import TopicAreaFormPage from './pages/TopicAreaFormPage';
import RawArchiveImportPage from './pages/RawArchiveImportPage';
import ArchiveListPage from './pages/ArchiveListPage';
import { ToastContainer } from 'react-toastify';
import NotificationPage from './pages/NotificationPage';
import GoogleCallback from './pages/GoogleCallback';
import RecommendedTimelinePage from './pages/RecommendedTimelinePage';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <Router>
            <Header />
          <NotificationSocket />
          <ToastContainer position="top-center" autoClose={2000} hideProgressBar aria-label="알림" />
          <ResponsiveLayout>
            <Routes>
              <Route path="/" element={<Navigate to="/recommended" replace />} />
              <Route path="/timeline" element={<Timeline />} />
              <Route path="/timeline/:topicAreaId" element={<Timeline />} />
              <Route path="/recommended" element={<RecommendedTimelinePage />} />
              <Route path="/content/:id" element={<ContentPage />} />
              <Route path="/content/:id/edit" element={<ContentEditPage />} />
              <Route path="/content/create" element={<ContentCreatePage />} />
              <Route path="/archives" element={<ArchiveListPage />} />
              <Route path="/boards/:category" element={<BoardPage />} />
              <Route path="/boards/:category/create" element={<BoardCreatePage />} />
              <Route path="/boards/:category/:id/edit" element={<BoardEditPage />} />
              <Route path="/boards/:category/:id" element={<BoardDetailPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/mypage" element={<MyPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/api-docs" element={<ApiDocsPage />} />
              <Route path="/category-manage" element={<CategoryManagePage />} />
              <Route path="/topic-areas" element={<TopicAreaListPage />} />
              <Route path="/topic-areas/new" element={<TopicAreaFormPage />} />
              <Route path="/topic-areas/:id" element={<TopicAreaDetailPage />} />
              <Route path="/topic-areas/:id/raw-import" element={<RawArchiveImportPage />} />
              <Route path="/topic-areas/:id/edit" element={<TopicAreaFormPage />} />
              <Route path="/notifications" element={<NotificationPage />} />
              <Route path="/oauth/google/callback" element={<GoogleCallback />} />
            </Routes>
          </ResponsiveLayout>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  </ErrorBoundary>
);
}
export default App; 
